module.exports = __webpack_public_path__ + "static/media/homeshowlogos-01.d347edde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeshowlogos-01.jpg
// module id = 375
// module chunks = 0